<template>
  <div class="policy-form" v-loading="saving">
    <el-card shadow="always">
      <div slot="header">
        Update Policy
      </div>
      <div class="labeled-text">
        <wysiwyg v-model="text" class="editor" />
      </div>
      <div slot="footer">
        <el-button type="primary" @click="savePolicy">Save</el-button>
        <slot name="buttons"></slot>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'PolicyForm',
    props: {
      policy: {
        type: Object,
      },
      onSuccess: {
        type: Function,
      },
    },
    data() {
      return {
        text: '',
        saving: false,
      };
    },
    created() {
      if (this.policy) {
        this.text = this.policy.text;
      }
    },
    computed: {
      ...mapGetters('entities/policies', ['creating', 'processing']),
    },
    methods: {
      ...mapActions('entities/policies', ['createPolicy', 'updatePolicy']),

      savePolicy() {
        const formData = {
          text: this.text,
        };
        if (this.policy) {
          this.$confirm('Updating the company policy will force users to accept it before submitting their timesheets.', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            title: 'Confirm',
          }).then(() => {
            this.saving = true;
            this.updatePolicy(formData)
              .then((response) => {
                if (response.status) {
                  showSuccessMessage('Policy has been updated.');
                  if (this.onSuccess) this.onSuccess();
                } else {
                  showErrorMessage(response.error);
                }
                this.saving = false;
              });
          });
        } else {
          this.saving = true;
          this.createPolicy(formData)
            .then((response) => {
              if (response.status) {
                showSuccessMessage('Policy has been created.');
                if (this.onSuccess) this.onSuccess();
              } else {
                showErrorMessage(response.error);
              }
              this.saving = false;
            });
        }
      },
    },

  };
</script>

<style lang="scss">
  .policy-form {
    .el-upload, .el-upload-dragger {
      width: 100%;
    }
  }
  .buttons{
    padding: 10px 0px;
  }
  .editor{
    min-height: 600px;
  }
  .editr--toolbar .dashboard{
    width: auto !important;
    right: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/policy/PolicyForm.vue